export const CARRIER_PLAYLISTS_CHANGE_TRACKING = {
  carrierPlaylistsCreate: {
    source: 'carrier_playlists.create',
    id: 12401,
  },
  carrierPlaylistsUpdate: {
    source: 'carrier_playlists.update',
    id: 12402,
  },
  carrierPlaylistsDelete: {
    source: 'carrier_playlists.delete',
    id: 12403,
  },
} as const;
